// @flow
export const CHANGE_ZONE = 'hive/notificationsUi/CHANGE_ZONE';
export const LOAD_NOTIFICATIONS = 'hive/notifications/LOAD';
export const RECEIVED_NOTIFICATIONS = 'hive/notifications/RECEIVED';
export const SAVE_NOTIFICATIONS = 'hive/notifications/SAVE';
export const SAVE_NOTIFICATIONS_ERROR = 'hive/notifications/SAVE_ERROR';
export const SAVED_NOTIFICATIONS = 'hive/notifications/SAVED';



// WEBPACK FOOTER //
// ./src/core/state/notifications/constants.js